<template>
    <div :class="classMainBlock">
        <label v-if="title">
            {{ title }}
        </label>

        <vue-multiselect
            v-model="itemModel"
            :close-on-select="true"
            :disabled="disabled"
            :maxHeight="200"
            :options="itemsData"
            :searchable="searchable"
            :show-labels="false"
            label="name"
            :placeholder="placeholder"
            track-by="id"
            @input="onChange"
        />
    </div>
</template>

<script>
export default {
    props: ['title', 'id', 'searchable', 'items', 'selected', 'route', 'classMainBlock', 'disabled', 'placeholder'],
    data: function () {
        return {
            itemModel: null,
            itemValue: null,
            itemsData: [],
        };
    },
    mounted() {
        this.getItems();
    },
    methods: {
        onChange() {
            let id = this.itemModel && (this.itemModel.id || this.itemModel.id === 0) ? this.itemModel.id : null;
            this.setValue(id);
            this.emitChange();
        },
        getItems() {
            if (this.items) {
                this.itemsData = this.items;
                this.setModelAndValue(this.selected);
                this.selected && this.emitChange();
            } else if (this.route) {
                axios.get(this.route).then((response) => {
                    this.itemsData = response.data;
                    this.setModelAndValue(this.selected);
                    this.selected && this.emitChange();
                });
            }
        },
        getValue() {
            return this.itemValue;
        },
        setModel(id) {
            this.itemModel = this.itemsData.filter((e) => e.id === id);
        },
        setValue(id) {
            this.itemValue = id;
        },
        setModelAndValue(ids) {
            this.setModel(ids);
            this.setValue(ids);
        },
        emitChange() {
            this.$emit('change', this.itemValue);
        },
        clear() {
            this.itemModel = this.itemValue = null;
        },
    },
};
</script>
